import { defineMessages } from 'react-intl';

export const filterFieldMessages = {
  ...defineMessages({
    ariaLabel: {
      defaultMessage: 'Filter field',
      id: 'swS1rIU8VQep1PDq',
      description: 'Default aria label for the filter field',
    },
    clearFilter: {
      defaultMessage: 'Clear filter',
      id: 'mS6CPzO+pMJLetSA',
      description:
        'Aria label used for the clear button inside the filter field.',
    },
    docsLink: {
      defaultMessage: 'Filter syntax',
      id: 'G0h1f2oRxQ8RBqNt',
      description:
        'Filter field suggestion tip - link to filter field documentation.',
    },
    placeholder: {
      defaultMessage: 'Type to filter',
      id: 'GhC5F6ZRFGDVs41W',
      description: 'Default placeholder text shown in the filter field.',
    },
    syntaxError: {
      defaultMessage: 'Invalid syntax.',
      id: 'ut5dPv/qM9qMEW4a',
      description:
        'Error message shown when the Input in the FilterField has an invalid syntax.',
    },
  }),

  /**
   * Comparison operators
   */
  comparisonOperators: defineMessages({
    equals: {
      defaultMessage: 'Equals',
      id: 'VsLm4+Io4PguyLI+',
      description: 'Filter field equals operator description',
    },
    notEquals: {
      defaultMessage: 'Doesn’t equal',
      id: 'Ce/f2UdApbmNAeEM',
      description: 'Filter field not equals operator description',
    },
    lessThan: {
      defaultMessage: 'Less than',
      id: 'JZunLfAY47K5StQb',
      description: 'Filter field less than operator description',
    },
    lessThanEqual: {
      defaultMessage: 'Less than or equal to',
      id: 'vJ/eXvQ9OL/qVOcs',
      description: 'Filter field less than or equal operator description',
    },
    greaterThan: {
      defaultMessage: 'Greater than',
      id: 'WDNrzGxjR2Q0PO0t',
      description: 'Filter field greater than operator description',
    },
    greaterThanEqual: {
      defaultMessage: 'Greater than or equal to',
      id: '+qNOmVAE1opriSnf',
      description: 'Filter field greater than or equal operator description',
    },
    in: {
      defaultMessage: 'Matches one or more values in a list of values',
      id: '2TgksAr68bjM6G9M',
      description: 'Filter field in operator description',
    },
    notIn: {
      defaultMessage: "Doesn't match one or more values in a list of values",
      id: '44M+LwJIb1lbO5Ev',
      description: 'Filter field not in operator description',
    },
    startsWith: {
      defaultMessage: 'Starts with',
      id: '7zZeVBfEiXm3xbwL',
      description: 'Filter field starts-with operator description',
    },
    contains: {
      defaultMessage: 'Contains',
      id: 'tChYdhQqWeoYUZrd',
      description: 'Filter field contains operator description',
    },
    endsWith: {
      defaultMessage: 'Ends with',
      id: 'Zc+msrZVGPNk84Lu',
      description: 'Filter field ends-with operator description',
    },
    notStartsWith: {
      defaultMessage: "Doesn't start with",
      id: 'dyadgwpDBQLyqJaa',
      description: 'Filter field not-starts-with operator description',
    },
    notContains: {
      defaultMessage: "Doesn't contain",
      id: 'jT47SZ4EuoZYSr9x',
      description: 'Filter field not-contains operator description',
    },
    notEndsWith: {
      defaultMessage: "Doesn't end with",
      id: '8fzPtb8YMF5R1xlh',
      description: 'Filter field not-ends-with operator description',
    },
    exists: {
      defaultMessage: 'Exists in any form',
      id: 'RSp2nSscx4hJgP2P',
      description: 'Filter field exists operator description',
    },
    notExists: {
      defaultMessage: "Doesn't exist in any form",
      id: 'E1oTbKDAzXJo/hs/',
      description: 'Filter field not exists operator description',
    },
    matchesPhrase: {
      defaultMessage: 'Matches phrase',
      id: 'TNgy+4XtLPGHfZu2',
      description: 'Filter field matches-phrase operator description',
    },
    notMatchesPhrase: {
      defaultMessage: 'Does not match phrase',
      id: 'Tr/buzcgyjaGCFM7',
      description: 'Filter field not-matches-phrase operator description',
    },
  }),

  /**
   * Unsupported operators
   */
  unsupportedOperators: defineMessages({
    startsWith: {
      defaultMessage: 'Starts-with is not supported for this key.',
      description:
        'Message shown if the starts-with operator is not supported for this key.',
      id: 'HChaOEcqD6o/jiDX',
    },
    endsWith: {
      defaultMessage: 'Ends-with is not supported for this key.',
      description:
        'Message shown if the ends-with operator is not supported for this key.',
      id: 'XRD3go4HQunmYuM4',
    },
    contains: {
      defaultMessage: 'Contains is not supported for this key.',
      description:
        'Message shown if the contains operator is not supported for this key.',
      id: '8lZa/1S3ydSfb3iO',
    },
  }),

  /**
   * Suggestions
   */
  suggestions: {
    ...defineMessages({
      loading: {
        defaultMessage: 'Loading suggestions',
        id: '313HlKgYmTnqRqJU',
        description: 'Message shown when suggestions are currently loaded.',
      },
      noSuggestions: {
        defaultMessage: 'No suggestions',
        id: 'PjDGLO7+f1/CNRR0',
        description: 'Filter field empty suggestions message.',
      },
      noMatchingSuggestions: {
        defaultMessage: 'No matching suggestions found.',
        id: 'vN/5FvuU1Cfk1/Ep',
        description:
          'Empty state message shown if no suggestions can be found.',
      },
      pasteRaw: {
        defaultMessage: 'Apply filter syntax',
        description:
          'Suggestion to enter the pasted text into the FilterField.',
        id: 'iQMNfVmL/0auzXXf',
      },
      pinnedFilters: {
        defaultMessage: 'Pinned filters',
        id: 'iuy+4WgQ89QDvgl+',
        description:
          'Headline for recently used filters suggestions in the filter field',
      },
      pinUnpinLabel: {
        defaultMessage:
          '{isPinned, select, true {Unpin} other {Pin}} filter with value "{filterString}',
        id: '9IaEBlhZa5HXmHA+',
        description:
          'Aria label for the pin/unpin button in the filter field suggestions',
      },
      pinUnpinTooltip: {
        defaultMessage: '{isPinned, select, true {Unpin} other {Pin}} filter',
        id: 'aj7w8W3lv+e41SJB',
        description:
          'Tooltip for the pin/unpin button in the filter field suggestions',
      },
      pinUnpinLimitTooltip: {
        defaultMessage: 'You can’t pin more than 10 items',
        id: 'Q7HxEz/6LQ+CtEXo',
        description: 'Tooltip for the pin/unpin if the limit is reached.',
      },
      recentlyUsed: {
        defaultMessage: 'Recently used filters',
        id: 'QGNAMlfBaYn7aCLl',
        description:
          'Headline for recently used filters suggestions in the filter field',
      },
      search: {
        defaultMessage:
          '{value, select, false {Search for a phrase} other {Search{value}}}',
        id: '3jYmiQ54m6nCawn6',
        description:
          'Empty state message shown if no key or value is provided yet.',
      },
      showMore: {
        defaultMessage:
          'Show {isExpanded, select, true {less} false {more} other{}}',
        id: 'b8jNkkwzLHYDkasb',
        description:
          'Text shown on the expanding button within the provided list, when currently expanded.',
      },
      startTyping: {
        defaultMessage: 'Start typing to enter a {suggestionType}.',
        id: 'Zr87lY6T9UiaWuMD',
        description:
          'Empty state message shown if no key or value is provided yet.',
      },
      useAsKey: {
        defaultMessage: 'Use{value}as key',
        description: 'Message shown as a default key suggestions.',
        id: 'pFUmTVhQadk/rQkO',
      },
      useAsValue: {
        defaultMessage: 'Use{value}as value',
        description:
          'Message shown if a generic value may be available in the suggestion.',
        id: '5E11MLQX1RFMIXOL',
      },
    }),
    supportedValues: defineMessages({
      Durations: {
        defaultMessage: 'Supported values: Durations',
        id: 'ZqPD+GJnri7vlLul',
        description:
          'Message shown for value suggestions restricted by a validator map (only durations are valid)',
      },
      Numbers: {
        defaultMessage: 'Supported values: Numbers',
        id: 'TGpKHavTfvNDG6nB',
        description:
          'Message shown for value suggestions restricted by a validator map (only numbers are valid)',
      },
      IPAddresses: {
        defaultMessage: 'Supported values: IP addresses',
        id: 'R78oo6l2CKe2fY1R',
        description:
          'Message shown for value suggestions restricted by a validator map (only IP addresses are valid)',
      },
      UIDs: {
        defaultMessage: 'Supported values: UIDs',
        id: 'BfMOguQOfnAxwOI6',
        description:
          'Message shown for value suggestions restricted by a validator map (only UIDs are valid)',
      },
      Timestamps: {
        defaultMessage: 'Supported values: Timestamps',
        id: '8KQslb+aIgOg9wbA',
        description:
          'Message shown for value suggestions restricted by a validator map (only Timestamps are valid)',
      },
      SmartscapeIds: {
        defaultMessage: 'Supported values: SmartscapeIds',
        id: '0VRyxKUSWrEGrYLJ',
        description:
          'Message shown for value suggestions restricted by a validator map (only SmartscapeIds are valid)',
      },
      Boolean: {
        defaultMessage: "Supported values: 'true', 'false'",
        id: '4Dfz/uq2jb0sD782',
        description:
          'Message shown for value suggestions restricted by a validator map (only "true" and "false" are valid)',
      },
    }),
    tips: defineMessages({
      apply: {
        defaultMessage: ' Apply filter',
        id: 'LOWAzLWj0fknrnEb',
        description: 'Filter field suggestion tip - apply filter.',
      },
      close: {
        defaultMessage: 'Close',
        id: 'RL8FCY3ia3BTX2cU',
        description: 'Filter field suggestion tip - close suggestions.',
      },
      selection: {
        defaultMessage: ' Navigate',
        id: 'HH0Od0c8jGTsxDda',
        description: 'Filter field suggestion tip - navigate suggestions.',
      },
    }),

    a11y: defineMessages({
      ariaLabel: {
        defaultMessage: 'Suggestions',
        id: 'BAfEyw7BhyJX3dfC',
        description: 'Aria label for the suggestions overlay',
      },
      noSuggestions: {
        defaultMessage: 'No suggestions available.',
        id: 'eII4gA0InOVMB0Uh',
        description: 'Aria text when there are no available suggestion.',
      },
      xMoreSuggestions: {
        id: 'HPt4l9OCXddkPdak',
        defaultMessage: '{suggestionsLength} suggestions available.',
        description: 'Aria text for more than 10 suggestions.',
      },
      availableSuggestions: {
        id: 'gbREY3JeG/Gnn5VH',
        defaultMessage:
          '{suggestionsLength} suggestions available: {combinedSuggestions}',
        description: 'Aria text for less than 10 suggestions.',
      },
      logicalOperators: {
        defaultMessage: 'Logical operator suggestions',
        id: 'r2QQIGUPC6lQhGDf',
        description:
          'Aria-label for logical operator suggestions in the filter field',
      },
      overlayAnnouncement: {
        defaultMessage:
          'Suggestions overlay opened. Press enter to apply the filter when no suggestion is focused. Please continue typing to filter.',
        id: 'SfuoDLpInG4rrNfA',
        description:
          'Filter field screen reader announcement for opened suggestions.',
      },
      pastedContent: {
        defaultMessage: 'Suggestions for pasted content',
        id: '4ccf9fJlKURtBw/8',
        description: 'Aria label for the pasted content suggestion group.',
      },
      statementSuggestions: {
        defaultMessage: 'Suggestions for filter statements',
        id: 'HzfsDA+42BHW9xeE',
        description: 'Aria label for the filter statements suggestion group.',
      },
      search: {
        defaultMessage: 'Search suggestion',
        id: 'd4ODG2WkdaedSe5s',
        description: 'Aria label for the search suggestion group.',
      },
    }),

    ariaLiveInfo: defineMessages({
      availableSuggestions: {
        defaultMessage: 'Available suggestions:',
        id: 'zSm9YklUFyPurvQU',
        description:
          'Screen reader announcement introducing the list of available filter suggestions.',
      },
      moreSuggestionsAvailable: {
        defaultMessage:
          'This is just an overview, more suggestions might be available. Continue typing to filter.',
        id: 'q2NfrgHXNjwfJzpm',
        description:
          'Screen reader announcement indicating that additional suggestions exist beyond the first five displayed.',
      },
      additionallyAvailableSuggestions: {
        defaultMessage: 'Additionally available suggestions:',
        id: 'nZQixLAUTDhflk9Q',
        description:
          'Screen reader announcement introducing additional suggestion categories such as recent, pinned, or search suggestions.',
      },
      logicalOperator: {
        defaultMessage: 'Logical operator suggestion: OR',
        id: 'p/8O9bMs2knnRDWA',
        description:
          'Screen reader announcement for the availability of the logical OR operator as a suggestion option.',
      },
      recentlyUsedSuggestions: {
        defaultMessage: '{value} recently used suggestion(s).',
        id: '1fdceSDwpC0elRzY',
        description:
          'Screen reader announcement for the count of recently used filter suggestions available for selection.',
      },
      pinnedSuggestions: {
        defaultMessage: '{value} pinned filter suggestion(s).',
        id: 'dtWYZ7eG/P5QCKp5',
        description:
          'Screen reader announcement for the count of user-pinned filter suggestions available for selection.',
      },
      filterCleared: {
        defaultMessage: 'Filter cleared.',
        id: 'Xt1ikxx+KzIHLF1C',
        description:
          'Screen reader announcement when the filter field value is cleared.',
      },
    }),
  },

  /**
   * Value suggestions
   */
  value: defineMessages({
    startsWith: {
      defaultMessage: 'Starts with {value}',
      description:
        'Message shown if the starts-with operator can be used with the current value.',
      id: '/gODMPYFdp49RodI',
    },
    endsWith: {
      defaultMessage: 'Ends with {value}',
      description:
        'Message shown if the ends-with operator can be used with the current value.',
      id: 's/C94DAW5sfrWYkU',
    },
    contains: {
      defaultMessage: 'Contains {value}',
      description:
        'Message shown if the contains operator can be used with the current value.',
      id: '7M6Jd0cEy/ruEDEZ',
    },
    notStartsWith: {
      defaultMessage: "Doesn't start with {value}",
      description:
        'Message shown if the not-starts-with operator can be used with the current value.',
      id: '9xnhCHCgU7NGIxiX',
    },
    notEndsWith: {
      defaultMessage: "Doesn't end with {value}",
      description:
        'Message shown if the not-ends-with operator can be used with the current value.',
      id: 'fJPc1Tw4jSAEp5KQ',
    },
    notContains: {
      defaultMessage: "Doesn't contain {value}",
      description:
        'Message shown if the not-contains operator can be used with the current value.',
      id: 'mXDFppLKSC7oX/Ba',
    },
  }),

  /**
   * Linting
   */
  linting: {
    ...defineMessages({
      emptyGroupError: {
        defaultMessage: 'A group cannot be empty.',
        id: 'U4LTHt7BSgC51Yri',
        description: 'Filter field empty group error',
      },
      incompleteGroupError: {
        defaultMessage: 'A group seems to be missing a bracket.',
        id: '1TnPlwjdgpaLY1uE',
        description: 'Filter field incomplete group error',
      },
      unsupportedExplicitGroup: {
        defaultMessage:
          'Grouping statements is not supported in the basic syntax mode.',
        id: '/jHof2z8yLr/qa9U',
        description: 'Filter field unsupported group',
      },
      unsupportedPositionOperator: {
        defaultMessage: 'A position operator cannot occur in this position.',
        id: 'aUi1nca6cF4KJPSw',
        description: 'Filter field unsupported position operator',
      },
      duplicatePositionOperator: {
        defaultMessage:
          'A position operator can only occur before or after a doublequote, not both.',
        id: 'l1RC/QWjUJWHIM++',
        description: 'Filter field duplicate position operator error',
      },
      invalidPositionOperator: {
        defaultMessage:
          'Invalid combination of position operators and comparator.\nAllowed comparators: =, !=',
        id: 'nS4QPK3zNih9UAZs',
        description: 'Position operator not supported for used comparator.',
      },
      incompleteStatementError: {
        defaultMessage: 'The filter field statement is incomplete.',
        id: 'jtrx2KCeXnLeA8Kd',
        description: 'Filter field incomplete statement error',
      },
      incompleteStatementWithEnabledSearchError: {
        defaultMessage:
          'Incomplete filter statement. A valid statement consists of key, comparator, and value. Alternatively, add {operator} in front to search for this phrase in all data.',
        id: 'lrDYNZ+hnaBD30/j',
        description: 'Filter field incomplete statement error',
      },
      missingKeyError: {
        defaultMessage: 'The filter key is missing.',
        id: '1yn5LJXBZlEagfkL',
        description: 'Filter field missing key error',
      },
      missingValueError: {
        defaultMessage: 'The filter value is missing.',
        id: 'kctf0+Hea33LxYTL',
        description: 'Filter field missing value error',
      },
      missingOperatorError: {
        defaultMessage: 'Missing operator.',
        id: 'ABXa8Ni5H9+ZO7E0',
        description: 'Filter field missing operator',
      },
      invalidComparatorError: {
        defaultMessage:
          'Invalid comparator. Allowed comparators are: {allowedComparators}.',
        id: 'Fik0kx8pJ4hkEZUZ',
        description: 'Filter field invalid comparator',
      },
      invalidLogicalOperator: {
        defaultMessage: 'A logical operator cannot occur in this position.',
        id: '5Byu0D+YGc1DoTBc',
        description: 'Filter field invalid logical operator',
      },
      unsupportedLogicalOperator: {
        defaultMessage:
          'The logical `OR` operator is not supported in the basic syntax mode.',
        id: 'PkWNcYRn4iWtpXnu',
        description: 'Filter field unsupported logical operator',
      },
      invalidInclusionValue: {
        defaultMessage:
          "The 'in' operator requires values to be wrapped in brackets, separated by a comma.",
        id: 'tC4AzRIolPCwyigk',
        description: 'Filter field invalid inclusion value',
      },
      emptyInclusionValue: {
        defaultMessage: "The 'in' operator doesn't support empty lists.",
        id: 'LAcIIvdezwZIzQG+',
        description: 'Filter field empty inclusion value',
      },
      missingSpace: {
        defaultMessage: 'A space seems to be missing.',
        id: 'Q7Mgijk38uWvSnlW',
        description: 'Filter field missing space error',
      },
      invalidKey: {
        defaultMessage: 'Invalid filter key.',
        id: 'rfUQCaEOsY282TT4',
        description: 'Filter field invalid key error',
      },
      invalidWildCardOperator: {
        defaultMessage: 'This wildcard operator is not valid for this key.',
        id: 'j7ELo0pUXF1X46+R',
        description: 'Filter field invalid wildcard operator',
      },
      invalidWildCardOperatorInList: {
        defaultMessage:
          "Wildcards '*' aren't supported in lists. To include an asterisk in a value, escape it by adding a backslash '\\' in front or wrapping the value in double quotes.",
        id: '2BSsAVmKpHHX76YB',
        description: 'Filter field invalid wildcard operator in list',
      },
      invalidCharacterInIdentifier: {
        defaultMessage:
          "Reserved characters aren't allowed in keys or values. Escape them by adding a backslash '\\' in front or wrapping the whole string in double quotes.",
        id: 'lLbR2C5+S97CTJ4v',
        description: 'Filter field invalid characters',
      },
      invalidDecimalSeparatorInNumber: {
        defaultMessage:
          'Use a period as the decimal separator (for example, 3.5)',
        id: 'peQntgQSmqMbRmBI',
        description: 'Filter field comma used as decimal separator in number',
      },
      unsupportedSearchOperator: {
        defaultMessage:
          'The search operator is not supported in this filter field.',
        id: '1xChk0S6M7Z4tXFB',
        description: 'Filter field unsupported search operator',
      },
      unsupportedSearchWithLogicalOr: {
        defaultMessage:
          'Filter and search statements can only be combined using an {allowedOperator}.',
        id: '+Q75VFLIzDqeN+do',
        description: 'Filter field unsupported search operator and logical or',
      },
      invalidSearchOperatorInGroup: {
        defaultMessage: "Search statements aren't supported in groups.",
        id: '7eS8L2HEADvzM6q2',
        description: 'Filter field invalid search operator inside group',
      },
      invalidValueErrorGeneric: {
        defaultMessage: 'Invalid filter value.',
        id: '0pTypH/J5FqapHUE',
        description: 'Filter field invalid value error',
      },
      invalidValueErrorDurations: {
        defaultMessage:
          "Invalid filter value. Only durations are supported as values for this key, for example, '200ms'.",
        id: 'yBhOkj2PXbKg2Tjc',
        description: 'Invalid value error for duration type',
      },
      invalidValueErrorNumbers: {
        defaultMessage:
          'Invalid filter value. Only numerical values are supported for this key.',
        id: 'J2NKmHJhslvMRQcz',
        description: 'Invalid value error for number type',
      },
      invalidValueErrorStrings: {
        defaultMessage:
          'Invalid filter value. Only text values are supported for this key.',
        id: '2DJQNdEozwBZPASX',
        description: 'Invalid value error for text type',
      },
      invalidValueErrorIPAddresses: {
        defaultMessage:
          'Invalid filter value. Only IPv4 and IPv6 addresses are supported for this key.',
        id: 'Ew2zazlMNmEr1jna',
        description: 'Invalid value error for IP address type',
      },
      invalidValueErrorUIDs: {
        defaultMessage:
          'Invalid filter value. Only uid64, uid128 and uuid formats are supported for this key.',
        id: '3zpFLdLODjLHgabp',
        description: 'Invalid value error for UID type',
      },
      invalidValueErrorTimestamps: {
        defaultMessage:
          'Invalid filter value. Only timestamps in ISO8601 format are supported for this key.',
        id: 'stPGS1LgPweLqQcm',
        description: 'Invalid value error for timestamp type',
      },
      invalidValueErrorSmartscapeIds: {
        defaultMessage:
          'Invalid filter value. Only SmartscapeIds are supported for this key.',
        id: 'ajJBzmvnE0ruvyfn',
        description: 'Invalid value error for SmartscapeId type',
      },
      invalidValueErrorBoolean: {
        defaultMessage:
          "Invalid filter value. The supported values for this key are 'true' and 'false'.",
        id: '/dH1ZDxCvqGesp4H',
        description: 'Invalid value error for boolean type',
      },
      invalidValueErrorMultipleTypes: {
        defaultMessage:
          'Invalid filter value. Only values of type {allowedTypes} are supported for this key.',
        id: '83QccW/P4JcNgO6M',
        description:
          'Invalid value error when multiple types are allowed for a key',
      },
    }),
    typeLabels: defineMessages({
      Durations: {
        defaultMessage: 'duration',
        id: 'ait1f+4Ly9rcloeq',
        description:
          'Label for duration type used in mixed type error messages',
      },
      Numbers: {
        defaultMessage: 'number',
        id: 'k3/OeMKig2l4gCEJ',
        description: 'Label for number type used in mixed type error messages',
      },
      Strings: {
        defaultMessage: 'text',
        id: 'aNafGo8pDA0dJBLo',
        description: 'Label for string type used in mixed type error messages',
      },
      IPAddresses: {
        defaultMessage: 'IP address',
        id: '0h7hXAauFUZKiVcD',
        description:
          'Label for IP address type used in mixed type error messages',
      },
      UIDs: {
        defaultMessage: 'UID',
        id: 'G7XpORU3bjxuwkZF',
        description: 'Label for UID type used in mixed type error messages',
      },
      Timestamps: {
        defaultMessage: 'timestamp',
        id: 'vwffeGCYNgFdxEUq',
        description:
          'Label for timestamp type used in mixed type error messages',
      },
      SmartscapeIds: {
        defaultMessage: 'SmartscapeId',
        id: '62QNu9Nw8T2nbJHu',
        description:
          'Label for SmartscapeId type used in mixed type error messages',
      },
      Boolean: {
        defaultMessage: 'boolean',
        id: 'OLs+1KIFFvyM4iJv',
        description: 'Label for boolean type used in mixed type error messages',
      },
    }),
  },
};
